import React from 'react'
import './projects.scss'
import easyVetImage from '../../assets/images/easyVet.png'
import hwtbamImage from '../../assets/images/hwtbam.png'
import galleryImage from '../../assets/images/gallery.png'

const Projects = () => {
  return (
    <div className="projects-page">
      <h1 className="projects-title">Highlighted Projects</h1>
      <div className="projects-container">
        <div
          className="project-card"
          onClick={() =>
            window.open('https://www.youtube.com/watch?v=wxDf4Z5OBD0', '_blank')
          }
        >
          <img src={easyVetImage} alt="EasyVet project thumbnail" />
          <h3>EasyVet</h3>
          <p>Veterinary practice management software</p>
        </div>
        <div
          className="project-card main-project-card"
          onClick={() => window.open('https://tzimchiel.netlify.app', '_blank')}
        >
          <img src={galleryImage} alt="Custom Gallery project thumbnail" />
          <h3>Custom Gallery App</h3>
          <p>A personalized art gallery web experience</p>
        </div>
        <div
          className="project-card"
          onClick={() =>
            window.open('https://www.youtube.com/watch?v=wwugIV1Qq80', '_blank')
          }
        >
          <img src={hwtbamImage} alt="HWTBAM project thumbnail" />
          <h3>Who Wants to Be a Millionaire?</h3>
          <p>Trivia Game Show</p>
        </div>
      </div>
    </div>
  )
}

export default Projects
